export default __webpack_public_path__ + "static/media/84.c32aad2f.png";